var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuilderAi = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4.5C11.2761 4.5 11.5 4.72386 11.5 5C11.5 7.48528 13.5147 9.5 16 9.5C16.2761 9.5 16.5 9.72386 16.5 10C16.5 10.2761 16.2761 10.5 16 10.5C13.5147 10.5 11.5 12.5147 11.5 15C11.5 15.2761 11.2761 15.5 11 15.5C10.7239 15.5 10.5 15.2761 10.5 15C10.5 12.5147 8.48528 10.5 6 10.5C5.72386 10.5 5.5 10.2761 5.5 10C5.5 9.72386 5.72386 9.5 6 9.5C8.48528 9.5 10.5 7.48528 10.5 5C10.5 4.72386 10.7239 4.5 11 4.5ZM11 7.29448C10.4514 8.48801 9.48801 9.45139 8.29448 10C9.48801 10.5486 10.4514 11.512 11 12.7055C11.5486 11.512 12.512 10.5486 13.7055 10C12.512 9.45139 11.5486 8.48801 11 7.29448Z",
    fill: "#59BD39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 12.5C5.77614 12.5 6 12.7239 6 13C6 13.5523 6.44772 14 7 14C7.27614 14 7.5 14.2239 7.5 14.5C7.5 14.7761 7.27614 15 7 15C6.44772 15 6 15.4477 6 16C6 16.2761 5.77614 16.5 5.5 16.5C5.22386 16.5 5 16.2761 5 16C5 15.4477 4.55228 15 4 15C3.72386 15 3.5 14.7761 3.5 14.5C3.5 14.2239 3.72386 14 4 14C4.55228 14 5 13.5523 5 13C5 12.7239 5.22386 12.5 5.5 12.5ZM5.5 14.3229C5.44471 14.3856 5.38556 14.4447 5.32291 14.5C5.38556 14.5553 5.44471 14.6144 5.5 14.6771C5.55529 14.6144 5.61444 14.5553 5.67709 14.5C5.61444 14.4447 5.55529 14.3856 5.5 14.3229Z",
    fill: "#59BD39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 3.5C5.77614 3.5 6 3.72386 6 4C6 4.55228 6.44772 5 7 5C7.27614 5 7.5 5.22386 7.5 5.5C7.5 5.77614 7.27614 6 7 6C6.44772 6 6 6.44772 6 7C6 7.27614 5.77614 7.5 5.5 7.5C5.22386 7.5 5 7.27614 5 7C5 6.44772 4.55228 6 4 6C3.72386 6 3.5 5.77614 3.5 5.5C3.5 5.22386 3.72386 5 4 5C4.55228 5 5 4.55228 5 4C5 3.72386 5.22386 3.5 5.5 3.5ZM5.5 5.32291C5.44471 5.38556 5.38556 5.44471 5.32291 5.5C5.38556 5.55529 5.44471 5.61444 5.5 5.67709C5.55529 5.61444 5.61444 5.55529 5.67709 5.5C5.61444 5.44471 5.55529 5.38556 5.5 5.32291Z",
    fill: "#59BD39"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuilderAi);
export default ForwardRef;